<template>
  <ValidationObserver ui-view="" class="app-body" ref="observer" v-slot="{ invalid }" tag="div">
    <!-- <div ui-view="" class="app-body" id="view"> -->
    <div class="box mt-20">
      <div class="box-header">
        <!--담당직원정보-->
        <h3>{{$t('label.empInfo')}}</h3>
        <!-- 인증완료된 출입담당 임직원 정보입니다.(변경불가) -->
        <p>{{$t('label.empInfoDesc')}}</p>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">이름</span>
            </label>
            <div class="col-6 pt-2">

              <input type="text" class="form-control form-control-danger" disabled v-model="empData.empName">

            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">이메일</span>
            </label>
            <div class="col-6 pt-2">
              <input type="text" class="form-control form-control-success" disabled v-model="empData.empEmail">
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>{{$t('label.visitorInfoInput')}}</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>{{$t('label.visitorInfoInputDesc')}}</p>
      </div>
      <visitor-input :item="visitorItem" :isApplicant="true"/>
    </div>

    <div class="box mt-20">
      <div class="box-header">
        <div class="row">
          <div class="col-10">
            <!-- <h3>추가 방문자 정보 입력</h3> -->
            <h3>{{$t('label.extraInfoInput')}}</h3>
            <!-- <p>이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요.</p> -->
            <p>{{$t('label.extraInfoInputDesc')}}</p>
          </div>
          <div class="col-2 pt-2" style="display: flex;
      justify-content: flex-end;
      align-items: center;">
            <button class="btn btn-sm light-blue" @click="addVisitor()"><i class="icon-plus mr-5"></i>추가</button>
            &nbsp;
            <button class="btn btn-sm light-gray" @click="removeVisitor()"><i class="icon-minus mr-5"></i>제거</button>
          </div>
        </div>
      </div>
      <div  v-for="(item, index) in visitorList" :key="index" >
        <div class="box-header" :style="[{'border-top': index == 0 ? 'none' : '1px solid #e2e2e2'}]">
          <div class="row">
            <div class="col-10">
              <small>
                <label class="md-check">
                  <input type="checkbox" v-model="item.isChecked">
                  <i class="blue"></i>방문자 {{index + 1}}</label>
              </small>
            </div>
            <div class="col-2 pt-2" style="display: flex;
        justify-content: flex-end;
        align-items: center;">
              <button class="btn btn-m line-1 mr-10" @click="visitorOpen(item)">
                <i :class="['carat', item.isOpen ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
              </button>
            </div>
          </div>
        </div>
        <visitor-input :item="item"/>
      </div>
    </div>

    <div class="box mt-20">
      <div class="box-header">
        <!-- <h3>출입예정일 및 목적</h3> -->
        <h3>{{$t('label.visitDateAndSubject')}}</h3>
        <!-- <p>출입 기간과 방문 목적을 입력하세요.</p> -->
        <p>{{$t('label.visitDateAndSubjectDesc')}}</p>
      </div>
      <div class="box-body pb-1">

        <div class="form-group row">
          <label class="col-2 form-control-label">
            <span class="ess">출입기간</span>
          </label>
          <div class="col-6 pt-5">
            <div class="input-group date">
              <DatePicker class="form-control"
                          type="date"
                          range
                          :append-to-body="false"
                          :popup-style="{ left: 0}"
                          v-model="item.dateRange"
                          :clearable="false"
                          :editable="false"
                          :disabled-date="notBeforeToday"
                          @pick="handleRangePick"
                          @open="handleRangeOpen"
                          style="font-size: 12px;"
                          input-class="calendar-input"
                          :lang="lang">
                <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
              </DatePicker>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 form-control-label">
            <span class="ess">방문목적</span>
          </label>
          <div class="col-10">
            <label class="md-check mt-5 mb-15" :class="item.visitTypeCode == 1 ? 'checked' : ''">
              <input type="radio" name="visitTypeCode" checked="checked" v-model="item.visitTypeCode" value="1">
              <i class="blue"></i>
              <div class="check-box ml-6">
                <div class="check-tit ph-14 pv-9">정기점검 및 작업</div>
                <ul class="p-10" style="text-align:center">
                  <i class="icon-setting" style="font-size:45px"></i>
                </ul>
              </div>
            </label>
            <label class="md-check mt-5 mb-15" :class="item.visitTypeCode == 2 ? 'checked' : ''">
              <input type="radio" name="visitTypeCode" v-model="item.visitTypeCode" value="2">
              <i class="blue"></i>
              <div class="check-box ml-6">
                <div class="check-tit ph-14 pv-9">설비/시설 점검</div>
                <ul class="p-10" style="text-align:center">
                  <i class="icon-prod-businessApplication" style="font-size:45px"></i>
                </ul>
              </div>
            </label>
            <label class="md-check mt-5 mb-15" :class="item.visitTypeCode == 3 ? 'checked' : ''">
              <input type="radio" name="visitTypeCode" v-model="item.visitTypeCode" value="3">
              <i class="blue"></i>
              <div class="check-box ml-6">
                <div class="check-tit ph-14 pv-9">장애처리</div>
                <ul class="p-10" style="text-align:center">
                  <i class="icon-warning" style="font-size:45px"></i>
                </ul>
              </div>
            </label>
            <label class="md-check mt-5 mb-15" :class="item.visitTypeCode == 4 ? 'checked' : ''">
              <input type="radio" name="visitTypeCode" v-model="item.visitTypeCode" value="4">
              <i class="blue"></i>
              <div class="check-box ml-6">
                <div class="check-tit ph-14 pv-9">일반업무</div>
                <ul class="p-10" style="text-align:center">
                  <i class="icon-publish" style="font-size:45px"></i>
                </ul>
              </div>
            </label>

          </div>
        </div>


        <div class="form-group row">
          <label class="col-2 form-control-label">
            <span class="ess">방문목적상세</span>
          </label>
          <div class="col-6 pt-2">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" name="방문목적상세" class="form-control form-control-danger" v-model="item.visitTypeDetail"/>
              <span class="input-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

      </div>
    </div>


    <div class="box mt-20">
      <div class="box-header">
        <!-- <h3>선택정보 입력</h3> -->
        <h3>{{$t('label.etcInfo')}}</h3>
        <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
        <p>{{$t('label.etcInfoDesc')}}</p>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="">화물용 엘레베이터 사용 여부</span>
            </label>
            <div class="col-6 pt-2">
              <label class="col-12 form-control-label ">
                <small>
                  <label class="md-check" style="padding-left: 0px;">
                    <input type="checkbox" v-model="item.isElev" :disabled="!($route.query.locationCode == 'N2CDT001060' || $route.query.locationCode == 'N2CDT014070')">
                    <i class="blue"></i><span style="color: red;">담당 임직원 검토 후, 화물용 엘레베이터 사용이 승인되지 않을 수 있습니다.</span>
                  </label>
                </small>
              </label>
            </div>
          </div>
<!--          <div class="form-group row">-->
<!--            <label class="col-2 form-control-label">-->
<!--              <span class="">차종</span>-->
<!--            </label>-->
<!--            <div class="col-6 pt-2">-->
<!--              <ValidationProvider rules="min:2" v-slot="{ errors }">-->
<!--                <input type="text" name="차종" class="form-control form-control-danger" v-model="item.carModel"/>-->
<!--                <span class="input-error">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="form-group row">-->
<!--            <label class="col-2 form-control-label">-->
<!--              <span class="">차량번호</span>-->
<!--            </label>-->
<!--            <div class="col-6 pt-2">-->
<!--              <ValidationProvider rules="min:7" v-slot="{ errors }">-->
<!--                <input type="text" name="차량번호" class="form-control form-control-danger" v-model="item.carNumber"/>-->
<!--                <span class="input-error">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="">기타요청사항</span>
            </label>
            <div class="col-6 pt-2">
              <textarea class="form-control form-control-success" v-model="item.etc"> </textarea>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="btn-wrap mt-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="checkInfo()">다음<i class="icon-arrow-line-right ml-5"></i></button>
    </div>
  </ValidationObserver>
</template>
<script>
  import AssetTable from './AssetTable.vue'
  import VisitorInput from './VisitorInput.vue';
  import DatepickerOptions from '@/components/common/datepickerOptions'

  export default {
    components: { AssetTable, VisitorInput, DatepickerOptions},
    mixins: [DatepickerOptions],
    data() {
      return {
        saveApi: 'visitor/apply',
        showTimeRangePanel: false,
        item: {visitTypeCode: 1},
        visitor: {},
        visitorNumber: 1,
        visitorList:[],
        saveVisitorList:[],
        visitorItem: {},
        pickFrom: null,
        pickTo: null,
        dataIdcCode: this.$route.query.locationCode
      }
    },
    created(){
    },
    mounted(){
      this.init();
    },
    computed: {

      empData() {
        var result = {empName: ''};
        if(this.$store.getters['auth/employee']) {
          result = this.$store.getters['auth/employee'];
        }
        return result;
      }
    },
    methods: {
      async checkInfo(){
        const isValid = await this.$refs.observer.validate();

        if (!isValid) {
          // this.$toast.error(this.$t('error.addVisitorError'));
          this.noti('입력 오류', this.$t('error.addVisitorError'), 'danger');
          return;
        }
        if(this.visitorList.filter((item)=>{return item.isAgree}).length != this.visitorList.length){
          this.noti('입력 오류', '추가 방문자의 개인정보 수집 및 이용에 대한 동의를 획득하였음을 체크해 주세요.', 'danger');
          return
        }
        this.saveInfo();
      },
      saveInfo(){

        var query = Object.assign({},this.$route.query);
        var idcCode = query.locationCode;
        var tosObj = JSON.parse(query.tos);
        var tosList = [];
        var fromDate;
        var toDate;
        var visitorList = [];
        var saveVisitorList = [];
        this.visitorItem.isApplicant = 1;
        this.visitorItem.isAgree = 1;
        if(this.item.dateRange){
          fromDate = moment(this.item.dateRange[0]).valueOf();
          toDate = moment(this.item.dateRange[1]).valueOf();
        }
        Object.keys(tosObj).forEach((x)=>{
          var tos = {isAgree: Number(tosObj[x]) , tosIndex: Number(x)}
          tosList.push(tos);
        })
        visitorList.push(Object.assign({}, this.visitorItem));
        visitorList = visitorList.concat(JSON.parse(JSON.stringify(this.visitorList)));

        visitorList.forEach((v)=>{
          var visitorItem =  Object.assign({}, v)
          visitorItem = Object.assign(visitorItem, this.item);
          visitorItem = Object.assign(visitorItem, this.empData);
          //둘차이가???
          visitorItem.idcCode = idcCode;
          visitorItem.visitIdcCode = idcCode;
          if(visitorItem.visitTypeCode == 1){
            visitorItem.tosList = tosList;
          }else{
            visitorItem.tosList = [];
          }
          //visitorItem.isApplicant = 1;
          // visitorItem.visitorPhone = '010-0000-0000';
          visitorItem.toDate = toDate;
          visitorItem.fromDate = fromDate;
          visitorItem.visitorBirth = v.visitorBirth ? moment(v.visitorBirth).format("YYYY-MM-DD") : null;
          visitorItem.visitTypeCode = Number(visitorItem.visitTypeCode);
          visitorItem.isAgree = Number(visitorItem.isAgree);
          debugger;
          if(!visitorItem.assetList)
            visitorItem.assetList = [];
          saveVisitorList.push(visitorItem);
        })


        this.saveVisitorList = saveVisitorList;
        this.next();
      },
      visitorOpen(item){
        item.isOpen = !item.isOpen;
      },
      prev(){
        var query = Object.assign({},this.$route.query);
        this.$router.push({ path: '/app/main/agree', query: query})
      },
      next(){
        var query = Object.assign({},this.$route.query);
        var params = {};
        params.visitorList = this.saveVisitorList;

        this.$router.push({ name: 'checkInfo', query: query, params: params})
      },
      addVisitor(){
        this.visitorList.push(Object.assign({},{id: this.uuidv4(), isChecked: false, isApplicant: 0, isAgree: 0}));
      },
      removeVisitor(){
        this.visitorList = this.visitorList.filter((x) => {
          return x.isChecked == false;
        })
      },
      toggleTimeRangePanel(){
        this.showTimeRangePanel = !this.showTimeRangePanel;
      },
      handleRangePick(date) {
        this.pickFrom = date;
        this.pickTo = new Date(date.getTime() + 1000*60*60*24*6);
      },
      handleRangeOpen() {
        this.pickFrom = null;
        this.pickTo = null;
      },
      init(){
      },
      notBeforeToday(date) {
        if(this.pickTo != null) {
          return date < this.pickFrom || date > this.pickTo;
        }
        return date < new Date(new Date().setHours(0, 0, 0, 0));
      },
    }
  }
</script>
<style>
  /*.mx-btn-icon-double-left, .mx-btn-icon-double-right{*/
    /*display: none;*/
  /*}*/
</style>
